import React from "react";
import { useDataStatus } from "components-redesign/DataStatusBadge/DataStatusContext";
import { useAllCampaignBudgets } from "redux/campaignsBudgets/selectors";
import { getRunningCampaignsObject } from "redux/campaignStatus/campaignStatusSelectors";
import { useSelector } from "redux/hooks";
import { fetchCampaignsListStatistics } from "services/statistics/fetchFromStatistics";
import { CampaignPageNotificationType, NotificationReason } from "../../types";
import generateNotifications from "./generateNotifications";

export default function useCampaignStatisticNotifications() {
  const campaignsObject = useSelector(getRunningCampaignsObject);
  const budgetsMap = useAllCampaignBudgets();
  const { setStatisticsLastUpdated } = useDataStatus();
  const [campaignsListStatistics, setStatistics] = React.useState<any>([]);

  React.useEffect(() => {
    let isMounted = true;

    if (Object.keys(campaignsObject).length) {
      fetchCampaignsListStatistics()
        .then((stats) => {
          if (isMounted) {
            setStatistics(stats);
            setStatisticsLastUpdated?.(new Date());
          }
        })
        .catch();
    }

    return () => {
      isMounted = false;
    };
  }, [campaignsObject]);

  const asyncCampaignNotifications: Array<CampaignPageNotificationType> =
    React.useMemo(
      () =>
        generateNotifications(
          {
            data: campaignsListStatistics,
            reason: NotificationReason.campaignSpendOver90,
            condition: (s) =>
              s?.budget &&
              s?.spent > 0.9 * s?.budget &&
              !budgetsMap[s.id]?.length,
          },
          campaignsObject
        ),
      [campaignsObject, campaignsListStatistics]
    );

  return asyncCampaignNotifications;
}
